import React from 'react'

import Navbar from '../components/navbar/Navbar'
import Recovery from '../components/recovery/Recovery'
import Footer from '../components/footer/Footer'

const RecoveryPage = () => {
    return (
        <>
           <Navbar /> 
           <Recovery />
           <Footer />
        </>
    )
}

export default RecoveryPage
